import React from "react"
import { useTranslation } from "react-i18next"

/**
 * FullWidthCTABanner component
 * @param {string} text - The text to display in the banner
 * @param {string} buttonText - The text to display on the button
 * @param {string} buttonLink - The link to navigate to when the button is clicked
 * @param {function} buttonAction - The function to run when the button is clicked
 * @param {string} className - Additional classes to add to the banner
 * @returns A full width call to action banner
 */
const FullWidthCTABanner = ({
  text,
  buttonText,
  buttonLink = "/signup/",
  buttonAction,
  className,
}) => {
  const { t } = useTranslation()

  return (
    <div className={`${className ?? ""} full-width-cta-banner`}>
      <div className="container-fluid full-width-cta-banner__inner pt-10 pb-10">
        <span className="mb-0 h4 text-white">
          {text ?? t("common.trusted-by-thousands")}
        </span>

        {/* If button action passed, use that, fall back to link */}
        {buttonAction ? (
          <button onClick={buttonAction} className="btn btn--secondary btn--lg">
            {buttonText ?? t("common.try-free-14-days")}
          </button>
        ) : (
          <a href={buttonLink} className="btn btn--secondary btn--lg">
            {buttonText ?? t("common.try-free-14-days")}
          </a>
        )}
      </div>
    </div>
  )
}

export default FullWidthCTABanner
